import { gql } from '@apollo/client'

export const downloadSearchResults = gql`
  query DownloadSearchResults($searchInput: SearchInput!, $withRework: Boolean!) {
    search(searchInput: $searchInput) {
      groups {
        active
        captureDate {
          fromTimestamp
        }
        childCount
        id
        imageApids(limit: 1)
        coverages {
          place {
            fullName
          }
          recordType {
            name
          }
        }
        dateRange {
          fromTimestamp
          toTimestamp
        }
        lastImageRework @include(if: $withRework) {
          state
        }
        metadata {
          archivalReferenceNumber
          createdDate {
            fromTimestamp
          }
          creator
          custodian
          imageGroupNumber
          languages
          title
          volume
        }
        externalId
        indexedChildCount
        naturalGroupId
        phoenixAcquisitionIds
        properties(
          names: [
            "cameraOperator"
            "cameraOperator_Id"
            "cameraOperatorNumber"
            "needsRework"
            "originalMediaNumber"
            "originalWeekEnding"
          ]
        ) {
          name
          values
        }
      }
      nextPageToken
      totalCount
    }
  }
`

export const groupSearch = gql`
  query GroupSearch($placeId: ID, $searchInput: SearchInput!, $withRework: Boolean!) {
    getPlace(placeId: $placeId) {
      count
      fullName
      id
      latitude
      longitude
      name
      parents {
        id
        name
      }
      topLevelPlaceId
      type
    }

    search(searchInput: $searchInput) {
      groups {
        active
        captureDate {
          fromTimestamp
        }
        childCount
        childNumber
        coverages {
          place {
            fullName
          }
          recordType {
            name
          }
        }
        dateRange {
          fromTimestamp
          toTimestamp
        }
        externalId
        groupName
        id
        imageApids(limit: 1)
        inactiveChildCount
        indexedChildCount
        languages
        lastImageRework @include(if: $withRework) {
          state
        }
        metadata {
          archivalReferenceNumber
          createdDate {
            fromTimestamp
          }
          creator
          custodian
          imageGroupNumber
          languages
          modifiedDate {
            fromTimestamp
          }
          title
          volume
        }
        naturalGroupId
        parentGroupId
        phoenixAcquisitionIds
        properties(
          names: [
            "archiveReferenceNumber"
            "author"
            "cameraOperator"
            "creator"
            "custodian"
            "hasLegacyWatermark"
            "indexStatus"
            "language"
            "needsRework"
            "originalMediaNumber"
            "originalWeekEnding"
            "title"
            "volume"
          ]
        ) {
          name
          values
        }
        siblingCount
        types
        volumes
        workflowActions {
          name
          status
          userId
        }
      }
      selectedFields {
        date {
          calendar
          formalText
          lang
          original
          sortKey
          standardizedText
        }
        startDateAvailable {
          fromTimestamp
          toTimestamp
        }
      }
      totalCount
      whatFacets {
        count
        id
        name
        primaryRecordTypes {
          count
          id
          name
        }
        relatedRecordTypes {
          count
          id
          name
        }
      }
      whereFacets {
        count
        place {
          fromYear
          id
          latitude
          longitude
          name
          toYear
        }
      }
    }
  }
`

export const imageOrganizeStatus = gql`
  query ImageOrganizeStatus($rmsId: ID!) {
    imageOrganizeStatus(rmsId: $rmsId) {
      divide {
        status
        userId
      }
      correctMetadata {
        status
        userId
      }
    }
  }
`

export const siblingOrganizeActions = gql`
  query SiblingOrganizeActions($parentIds: [String!], $pageSize: Int = 50) {
    search(searchInput: { parentIds: $parentIds, hasOrganizeActions: true, pageSize: $pageSize }) {
      groups {
        groupName
        id
        workflowActions {
          name
          status
          userId
        }
      }
    }
  }
`

export const allCountries = gql`
  query Countries {
    countries {
      id
      latitude
      longitude
      name
    }
  }
`
